module.exports = __webpack_public_path__ + "static/img/Hearts.eef90901.png";